import { render, staticRenderFns } from "./WxLogin.vue?vue&type=template&id=5c721413&scoped=true"
import script from "./WxLogin.vue?vue&type=script&lang=js"
export * from "./WxLogin.vue?vue&type=script&lang=js"
import style0 from "./WxLogin.vue?vue&type=style&index=0&id=5c721413&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c721413",
  null
  
)

export default component.exports